import {messageColors} from '../helper/messageColors';

import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';
import {codeLanguages} from '../resources/codeLanguages';

import MenuDownSvg from '@mdi/svg/svg/menu-down.svg';

const dropdownColors = [{name: 'No format', value: ''}, ...messageColors];

export default class ContainerMessageNodeView {
    constructor(node, view, getPos) {
        this.view = view;
        this.getPos = getPos;
        this.node = node;

        const messageColor = this.node.attrs.variation || '';

        this.colorDropdown = document.createElement('div');
        this.colorDropdown.className = 'detail ui mini search dropdown';

        if (this.view.editable) {
          this.colorDropdown.innerHTML = `<div class="default text">${dropdownColors.find(color => color.value === messageColor).name}</div> <img class="icon-12 ui icon" src="${MenuDownSvg}" alt="">`;

          const applyColorChange = (text, value) => {
            if (messageColor === value.trim()) {
              return;
            }

            const transaction = this.view.state.tr.setNodeMarkup(this.getPos(), undefined, {
              variation: value.trim(),
            });
            this.view.dispatch(transaction);
            this.view.focus();
          }

          $(this.colorDropdown).dropdown({
            values: dropdownColors,
            variation: 'scrolling',
            action: applyColorChange,
            duration: 0
          }).dropdown('set selected', messageColor);
        } else {
          this.colorDropdown.innerHTML = `<div class="text">${dropdownColors.hasOwnProperty(messageColor) ? codeLanguages[language].text : 'Code'}</div>`;
          this.colorDropdown.classList.add('disabled');
        }

        const content = document.createElement('div');
        content.className = 'ui visible message' + (node.attrs.variation ? ` ${node.attrs.variation}` : '');

        const colors = document.createElement('div');
        colors.className = 'ui top left attached label';
        colors.appendChild(this.colorDropdown);
        colors.setAttribute('contenteditable', 'false');

        const message = document.createElement('div');
        message.className = 'ui fitted basic segment message-block';
        message.appendChild(content);
        message.appendChild(colors);

        this.dom = message;
        this.contentDOM = content;
    }

    ignoreMutation() {
        return true;
    }

    destroy() {
        $(this.colorDropdown).dropdown('destroy');
        this.dom.remove();
        this.contentDOM.remove();
        delete this.dom;
        delete this.contentDOM;
    }
}